import { request, refreshAccessToken } from './_core'

// ── Auth ──────────────────────────────────────────────────────

export interface AuthUser {
  id:             string
  email:          string
  displayName:    string | null
  tier:           'BASIC' | 'PLUS' | 'PREMIUM'
  role:           'USER' | 'ADMIN'
  isProfessional: boolean
}

interface AuthResponse {
  accessToken: string
  user: AuthUser
}

export const auth = {
  register: (email: string, password: string, displayName?: string) =>
    request<{ message: string }>('/auth/register', {
      method: 'POST',
      body:   JSON.stringify({ email, password, displayName }),
    }),

  login: (email: string, password: string) =>
    request<AuthResponse>('/auth/login', {
      method: 'POST',
      body:   JSON.stringify({ email, password }),
    }),

  logout: () =>
    request<void>('/auth/logout', { method: 'POST', body: '{}' }).catch(() => undefined),

  refresh: refreshAccessToken,

  verifyEmail: (token: string) =>
    request<AuthResponse>(`/auth/verify-email?token=${encodeURIComponent(token)}`),

  resendVerification: (email: string) =>
    request<{ message: string }>('/auth/resend-verification', {
      method: 'POST',
      body:   JSON.stringify({ email }),
    }),

  forgotPassword: (email: string) =>
    request<{ message: string }>('/auth/forgot-password', {
      method: 'POST',
      body:   JSON.stringify({ email }),
    }),

  resetPassword: (token: string, newPassword: string) =>
    request<{ message: string }>('/auth/reset-password', {
      method: 'POST',
      body:   JSON.stringify({ token, newPassword }),
    }),
}
